import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import OuraNav from "../components/OuraNav";
import TimesheetView from "../components/TimesheetView";

const AdminTimesheetDetailPage = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode") === "created" ? "created" : "live";

    return (
        <>
            <OuraNav links={[{ label: "Dashboard", href: "/admin-dashboard" }]} />
            <div style={{ maxWidth: "900px", margin: "0 auto", padding: "80px 20px 40px" }}>
                <style>{`
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                    }
                `}</style>
                <div className="no-print" style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
                    <button
                        onClick={() => window.print()}
                        style={{ background: "#0071e3", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 16px", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}
                    >
                        Print / Save
                    </button>
                </div>

                <TimesheetView timesheetId={id} mode={mode} />
            </div>
        </>
    );
};

export default AdminTimesheetDetailPage;